export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface IVesselInformationMySuffix {
    id?: number;
    imoNumber?: string;
    name?: string;
    category?: string;
    sttaus?: string;
    yearOfBuilt?: string;
    classicficationSociety?: string;
    pAndIClub?: string;
    dateOfNextSurvey?: string;
    activeStatus?: ActiveStatus;
    lastModifiedBy?: string;
    createdByUserRole?: string;
    enableSanctionScreening?:boolean;
    finscanResultStatus?:string
}

export class VesselInformationMySuffix implements IVesselInformationMySuffix {
    constructor(
        public id?: number,
        public imoNumber?: string,
        public name?: string,
        public category?: string,
        public sttaus?: string,
        public yearOfBuilt?: string,
        public classicficationSociety?: string,
        public pAndIClub?: string,
        public dateOfNextSurvey?: string,
        public activeStatus?: ActiveStatus,
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public enableSanctionScreening?:boolean,
        public  finscanResultStatus?:string
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
    }
}
